module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAAAuElEQVR4Ae3NgQbDQBBF0fs3RSAQCNi/iQJQFEX+t4QIaYCUVcMEIw8lmAdmLfeQk5fLjYz/ze/sGqHnFULPS4Selwg9LxF6Xif0/GbXRyCEfLG7sOlEnF8pYC8orDoR5XtwAPQiEeSXmveATgT5Do6AEYtO+PxseQfYOp3w+RYioBKzQLj8ZPkIgFYjXpZvIAIcMf1+npzYg533IR8D0FTizskN3EABKjGgTAaA6wIJJJBAArlc7gugZwk6uoHeTwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/Entitytypeview/baseline_arrow_upward_black_24dp.png
// module id = 141
// module chunks = 0